import { fetchData } from "@client";

export async function getAnnouncementsQuery() {
  const res = await fetchData("/announcements");
  return res.results?.[0];
}
